import { jsx as s } from "react/jsx-runtime";
import { useRef as u, useState as m, useEffect as p } from "react";
import { c as y } from "../../index-BkL7vJ-E.js";
import v from "../../helpers/checkIp.js";
import k from "./IPCheckCover.js";
import { s as I } from "../../IPCheck.module-D80DEiWS.js";
const w = ({ ip: o, serviceUrl: i, children: a, videoCover: f }) => {
  const t = u(null), [n, c] = m(null), r = u(!1), h = () => {
    if ((location.hostname === "localhost" || location.hostname === "127.0.0.1") && o === "::1") {
      r.current = !0, c(!0);
      return;
    }
    v(i, o).then((e) => {
      if (!(e != null && e.data)) throw new Error("cancel_by_ip");
      r.current = !0, c(!0);
    }).catch(() => {
      r.current = !1, c(!1);
    });
  };
  if (p(() => {
    if (!n || !r.current) return () => {
    };
    const e = setInterval(() => {
      if (!t.current) return;
      const l = t.current.querySelector(".vjs-big-play-button");
      l && (l.dispatchEvent(new MouseEvent("click")), r.current = !1, clearInterval(e));
    }, 100);
    return () => {
      clearInterval(e);
    };
  }, [n, t]), typeof a != "function") {
    console.error("children prop must be a function!");
    return;
  }
  return /* @__PURE__ */ s(
    "div",
    {
      ref: t,
      className: y(
        I.container,
        "hamrah-player__check-ip"
      ),
      children: n === null ? /* @__PURE__ */ s(k, { videoCover: f, checkIp: h }) : a(n)
    }
  );
};
export {
  w as default
};
